<template>
    <b-modal
        id="thanksmodal"
        class="thanksModal"
        title="BootstrapVue"
        hide-header
        hide-footer
        centered
        static
        size="xl"
        scrollable
    >
        <div class="p-5">
            <div v-if="isFirmSaved" class="row">
                <div class="col-12">
                    <h2 class="title">Děkujeme</h2>

                    <div v-if="firm.presentation.id == '1'">
                        <presentation1></presentation1>
                    </div>
                    <div v-else-if="firm.presentation.id == '2'">
                        <presentation2></presentation2>
                    </div>
                    <div v-else-if="firm.presentation.id == '3'">
                        <presentation3></presentation3>
                    </div>
                    <div v-else>
                        Upps, tato varianta nemá žádný text.
                    </div>
                </div>
            </div>
            <div v-else>
                <span class="text-danger">
                    <div class="spinner-border" role="status">
                        <span class="sr-only">Načítám...</span>
                    </div>
                </span>
            </div>
        </div>
    </b-modal>
</template>

<script>
import Presentation1 from './dialogs/Presentation1'
import Presentation2 from './dialogs/Presentation2'
import Presentation3 from './dialogs/Presentation3'

export default {
    components: {
        Presentation1,
        Presentation2,
        Presentation3,
    },
    computed: {
        firm() {
            return this.$store.state.firm
        },
        linkToSS() {
            return `http://scripts.ci.cz/toSS.php?web=ceskestavby&fid=${this.firm.result.id_firmy}&ftoken=${this.firm.result.opravny_kod}`
        },
        isFirmSaved() {
            return this.$store.state.step.firmSaved
        },
    },
    methods: {
        showThanksModal() {
            //this.$modal.show('thanks');
            console.log('show')
            this.$bvModal.show('thanksmodal')
        },
        hideThanksModal() {
            this.$bvModal.hide('thanksmodal')
        },
    },
}
</script>
